import React from "react"
import menu from "../data/menu.json"
import { Link, withPrefix } from "gatsby"

export default function DownloadFullReport({ location, title, title_size }) {
  const downloads = menu.find(item => {
    return item.name === "Downloads"
  }).children
  const downloadLink = downloads.find(item => {
    return item.name === "Download Full Report"
  })
  const reports = downloads.find(item => {
    return item.name === "Download Full Report"
  }).children

  return reports ? (
    <div
      className={
        location
          ? `download-full-report download-full-report--${location}`
          : "download-full-report"
      }
    >
      <h3
        className={`title title--${
          title_size ? title_size : "r"
        } title--uppercase`}
      >
        {title ? title : "Download the report"}
      </h3>
      <ul>
        {reports.map((item, index) => (
          <li key={index} lang={item.lang}>
            {item.href.includes(".pdf") ? (
              <a
                href={withPrefix("/") + item.href}
                className="title title--xs title--bold"
              >
                {item.name}
              </a>
            ) : (
              <Link to={item.href} className="title title--xs title--bold">
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <>
      {downloadLink.href.includes(".pdf") ? (
        <a
          href={withPrefix("/") + downloadLink.href}
          className="title title--s"
        >
          {downloadLink.name}
        </a>
      ) : (
        <Link to={downloadLink.href} className="title title--s">
          {downloadLink.name}
        </Link>
      )}
    </>
  )
}
